import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SyncComponent } from './pages/Sync/Sync.component';

const routes: Routes = [
  { path: '', loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule) },
  {
    path: "**",
    redirectTo: "",
  }];

@NgModule({
  imports: [RouterModule.forRoot(routes,{
    useHash: false,
    enableTracing: true,
    onSameUrlNavigation: `reload`,
  }),
  RouterModule.forChild(routes),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
